@if ((isAuthorized | async)) {
  <a class="navbar-item" [routerLink]="navbarItem.link" [ngClass]="(isActive | async) ? 'active' : ''"
    [title]="navbarItem.text" (click)="onClick()">
    <div class="navbar-item">
      <div class="menu">
        <i class="fa-2x fa-fw" [ngClass]="navbarItem.icon" aria-hidden="true">
          <!-- <aa-warning-badge [warningBadgeValue]="value"></aa-warning-badge> -->
        </i>
        <p class="text">{{ navbarItem.text }}</p>
      </div>
      @if (navbarItem.soon) {
        <div class="new-ribbon">
          {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
        </div>
      }
      @if (navbarItem.nuovo) {
        <div class="new-ribbon">
          {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
        </div>
      }
    </div>
  </a>
} @else {
  <div class="navbar-item disabled">
    <div class="menu">
      <i class="fa-2x fa-fw" [ngClass]="navbarItem.icon" aria-hidden="true"></i>
      <p class="text">{{ navbarItem.text }}</p>
    </div>
    @if (navbarItem.soon) {
      <div class="new-ribbon">
        {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
      </div>
    }
    @if (navbarItem.nuovo) {
      <div class="new-ribbon">
        {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
      </div>
    }
  </div>
}
